import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import TextInput from "@/modules/common/components/ui-kit/inputs/text-input";

const LeadInputSection = ({
  searchParentLeadId,
  searchChildLeadId,
  handleParentLeadChange,
  handleChildLeadChange,
}: {
  searchParentLeadId: string | number;
  searchChildLeadId: string | number;
  handleParentLeadChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChildLeadChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: nawyTheme.nawy.spacing.md,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: nawyTheme.nawy.spacing.xxs,
          width: "50%",
        }}
      >
        <Typography
          sx={{
            ...nawyTheme.nawy.typography.english.variants.body.xs.semibold,
            color: nawyTheme.nawy.colors.semantic.text.secondary,
            textAlign: "left",
          }}
        >
          Parent Lead
        </Typography>
        <TextInput
          value={searchParentLeadId}
          onChange={handleParentLeadChange}
          disabled={true}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: nawyTheme.nawy.spacing.xxs,
          width: "50%",
        }}
      >
        <Typography
          sx={{
            ...nawyTheme.nawy.typography.english.variants.body.xs.semibold,
            color: nawyTheme.nawy.colors.semantic.text.secondary,
            textAlign: "left",
          }}
        >
          Child Lead
        </Typography>
        <TextInput
          value={searchChildLeadId}
          onChange={handleChildLeadChange}
          placeholder="Enter child lead ID"
        />
      </Box>
    </Box>
  );
};

export default LeadInputSection;
